
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractRecycleDetailsApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contract-recycle-details'
  }

}
